
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component
export default class AccordionItem extends Vue {
  private id = `accordion-collapse-${(~~(Math.random() * 1e8)).toString(16)}`

  @Prop({ required: true }) readonly title!: string
}
